import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { SigninModule } from './signin/signin.module';
import { RegPageModule } from './reg-page/reg-page.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginModule } from './login/login.module';
import { SocialRegisterModule } from './social-register/social-register.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';

@NgModule({
    declarations: [],  
    imports: [
        CommonModule, 
        FormsModule,
        LoginModule, 
        RegPageModule, 
        SigninModule, 
        SocialRegisterModule, 
        ForgotPasswordModule 
    ], 
    exports: [], 
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, 
        NO_ERRORS_SCHEMA
    ]
})
export class AuthModule {}